import { Box, Link } from '@mui/material';
import ROUTE from '../../../utils/router'
import { Link as RouterLink, useLocation } from 'react-router-dom'

const MenuBox = ({ isMobile, onNavigate }) => {
    const { pathname } = useLocation()
    const mainRoutes = ROUTE.find(route => route.componentName === 'PublicLayout')
    const childrenRouters = mainRoutes.children.filter(route => route.menu && (isMobile || !route.onlyMobile))
    const handleNavigate = (to) => {
        if (pathname === to && onNavigate) {
            onNavigate()
        }
    }

    return (
        <>
            <Box
                display="flex"
                alignItems={isMobile ? 'flex-start' : 'center'}
                flexDirection={isMobile ? 'column' : 'row'}
                gap={isMobile ? 2 : 3}
                p={isMobile ? 2 : 0}
            >
                {childrenRouters.map(route => {
                    const to = route.index ? mainRoutes.path : `/${route.path}`

                    return (
                        <Link
                            key={`main_menu_${route.path}`}
                            component={RouterLink}
                            to={to}
                            onClick={() => handleNavigate(to)}
                            color="text.primary"
                            underline="none"
                            sx={{ '&:hover': { color: 'primary.main' } }}
                        >
                            {route.title}
                        </Link>
                    )
                })}
            </Box>
        </>
    );
};

export default MenuBox;